import lowerCase from "lodash/lowerCase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function userNotify(msg, msgtype) {
  const pos = { position: toast.POSITION.TOP_RIGHT };
  switch (lowerCase(msgtype)) {
    case "warning":
    case "danger":
    case "error":
    case "info":
      toast.error(msg, pos);
      break;
    case "success":
    case "shortlist":
      toast.success(msg, pos);
      break;
    default:
      toast.error(msg, pos);
  }
}
